<ul>
    <li routerLinkActive="active" [routerLink]="'/secondees-list'">
        {{'secondees_list.title' | translate}}
    </li>
    <li routerLinkActive="active" [routerLink]="'/administration'">
        {{'administration.title' | translate}}
    </li>
</ul>